export default __webpack_public_path__ + "static/media/map_as.5d538cc4.png";